import Marquee from "react-fast-marquee";

const ENTITIES = ["MALLS", "EVENTS", "PARKS", "PUBLIC SIGHTS", "BUS STOPS", "RAILWAY STATIONS", "COLLEGES", "UNIVERSITIES"];

export default function EditorialMarquee() {
  return (
    <section className="border-y border-white/10 py-10 overflow-hidden bg-[#050505]" data-testid="entity-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ENTITIES.map((e) => (
          <span key={e} className="flex items-center">
            <span className="font-display font-black text-5xl lg:text-7xl text-outline mx-6 tracking-tight whitespace-nowrap">
              {e}
            </span>
            <span className="text-[#E5FF00] text-2xl mx-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
